// assets/slider-component.js
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    /* DOM refs */
    this.slider      = this.querySelector('[role="list"]');
    this.prevButton  = this.querySelector('.slider-button--prev');
    this.nextButton  = this.querySelector('.slider-button--next');
    this.counterNow  = this.querySelector('.slider-counter--current');
    this.counterMax  = this.querySelector('.slider-counter--total');

    /* Bind events */
    this.prevButton?.addEventListener('click',   () => this.move(-1));
    this.nextButton?.addEventListener('click',   () => this.move(+1));
    this.slider?.addEventListener('scroll',      this.throttle(this.update.bind(this), 100));

    /* Touch swipe (optional) */
    let startX;
    this.slider?.addEventListener('touchstart', e => startX = e.touches[0].clientX);
    this.slider?.addEventListener('touchend',   e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) this.move(dx > 0 ? -1 : +1);
    });

    /* Initialise */
    this.update();
    new ResizeObserver(() => this.update()).observe(this.slider);
  }

  /* Move n slides */
  move(step) {
    const itemWidth = this.slider.querySelector('.slider__slide')?.offsetWidth || 1;
    this.slider.scrollBy({ left: step * itemWidth, behavior: 'smooth' });
  }

  /* Update buttons + counter */
  update() {
    const itemWidth   = this.slider.querySelector('.slider__slide')?.offsetWidth || 1;
    const index       = Math.round(this.slider.scrollLeft / itemWidth);
    const total       = this.slider.childElementCount;

    this.counterNow.textContent = index + 1;
    this.counterMax.textContent = total;

    this.prevButton.disabled = index === 0;
    this.nextButton.disabled = index >= total - 1;
  }

  /* tiny throttle helper */
  throttle(fn, ms) {
    let running;
    return (...a) => { if (running) return; running = true;
      requestAnimationFrame(() => { fn(...a); setTimeout(()=>running=false, ms); });
    };
  }
}

customElements.define('slider-component', SliderComponent);
